import { FiEye } from "react-icons/fi";
import CRUDButton from "../CRUDButton";

import "./ViewButton.css";

function ViewButton({
  setShowModal,
  setShowViewSection,
  setTargetID,
  targetID,
}) {
  return (
    <CRUDButton
      handleClick={() => {
        setShowModal(true);
        setShowViewSection(true);
        setTargetID(targetID);
      }}
      dataTip="View"
      dataFor="View"
    >
      <FiEye />
    </CRUDButton>
  );
}

export default ViewButton;
